import { Grid, Row } from '@xing-com/xing-grid';

import { PeopleChildNameLink } from './people-child-name-link';
import { PeopleProfilePageLink } from './people-profile-page-link';
import { PageNamesTypes } from './types';
import type { PageName } from './types';
import { UserBagPageLink } from './user-bag-page-link';
import {
  StyledHalfWidthColumn,
  StyledFullWidthColumn,
} from './user-chunk.styles';

export type UserChunkProps = {
  names: Array<PageName>;
  fullWidthLayout: boolean;
};

export const UserChunk: React.FC<UserChunkProps> = ({
  names,
  fullWidthLayout,
}) => (
  <Grid>
    <Row>
      {names.map((item) => {
        switch (item.__typename) {
          case PageNamesTypes.child: {
            return (
              <StyledHalfWidthColumn
                sizeTiny={12}
                sizeWide={fullWidthLayout ? 4 : undefined}
                size={6}
                $fullWidthLayout={fullWidthLayout}
                key={item.name}
              >
                <PeopleChildNameLink {...item} />
              </StyledHalfWidthColumn>
            );
          }
          case PageNamesTypes.profile: {
            return (
              <StyledFullWidthColumn size={12} key={item.name}>
                <PeopleProfilePageLink {...item} />
              </StyledFullWidthColumn>
            );
          }
          case PageNamesTypes.userBag: {
            return (
              <StyledFullWidthColumn size={12} key={item.name}>
                <UserBagPageLink {...item} />
              </StyledFullWidthColumn>
            );
          }
        }
      })}
    </Row>
  </Grid>
);
